// extracted by mini-css-extract-plugin
export var container = "_g8-1";
export var cornerButtonContainer = "_g8-6";
export var disabled = "_g8-2";
export var dragActive = "_g8-3";
export var fileContainer = "_g8-5";
export var hiddenInput = "_g8-4";
export var widthContainer = "_g8-0";